// One current read per surface. Superseded responses cannot overwrite newer
// truth, clear a new loading state, or log out a replacement session.
export function createLatestWorkerRead() {
  let current = null;
  return {
    begin(identity) {
      current?.controller.abort();
      const ticket = { identity, controller: new AbortController() };
      current = ticket;
      return {
        signal: ticket.controller.signal,
        isCurrent: (identityNow = identity) => current === ticket && identityNow === identity && !ticket.controller.signal.aborted,
      };
    },
    cancel() {
      current?.controller.abort();
      current = null;
    },
  };
}

export function workerReadErrorMessage(error, surface = 'dashboard') {
  if (error?.code === 'ECONNABORTED' || error?.code === 'ETIMEDOUT') {
    return `Opening your ${surface} took too long. Please try again. Your saved information is still there.`;
  }
  return `We couldn’t open your ${surface}. Please try again. Your saved information is still there.`;
}

export function workerMutationErrorMessage(error, fallback) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;
  if (Array.isArray(detail)) {
    const messages = detail.map((item) => typeof item === 'string' ? item : item?.msg).filter(Boolean);
    if (messages.length) return messages.join('; ');
  }
  if (typeof detail?.message === 'string') return detail.message;
  return fallback;
}
